module.exports = __webpack_public_path__ + "static/media/econia.1d2f9ddf.png";